import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

import ContentHeader from 'component/utils/ContentHeader'
import IrcMenu from 'component/ircMenus/IrcMenu'

import { accessMenus } from '../../actions/menu'

class IrcMenus extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    accessMenus: PropTypes.func,
    auth: PropTypes.object,
    cdMenuChild: PropTypes.number,
  }

  render() {
    const {
      translate,
      accessMenus,
      cdMenuChild,
      auth: { user },
    } = this.props
    return (
      <>
        <ContentHeader>{translate('menu.irc.header.title')}</ContentHeader>

          <div style={{paddingTop: "43px"}} className='irc-menu-content-container'>

            <IrcMenu
              hasTitle
              headerTitle={"Loja"}
              translate={translate}
              title='totalAccuracy.title.button'
              text='ircMenus.totalAccuracy.description'
              root={'total-accuracy'}
              accessMenus={accessMenus}
              cdMenuChild={cdMenuChild}
              user={user}
            />

            <IrcMenu
              translate={translate}
              title='sectionAccuracy.title'
              text='ircMenus.sectionAccuracy.description'
              root={'sections-accuracy'}
              accessMenus={accessMenus}
              cdMenuChild={cdMenuChild}
              user={user}
            />

            { <IrcMenu
              translate={translate}
              title='rotativeInventory.stockCounting'
              text='ircMenus.stockCounting.description'
              root={'rotative-inventory'}
              accessMenus={accessMenus}
              cdMenuChild={cdMenuChild}
              user={user}
            /> }

            <IrcMenu
              translate={translate}
              title='higher.adjustments.IRC'
              text='higher.adjustments.IRC.description'
              root={'higher-adjustments'}
              accessMenus={accessMenus}
              cdMenuChild={cdMenuChild}
              user={user}
            />

            <IrcMenu
              translate={translate}
              title='ruptureIrc.rupture'
              text='ruptureIrc.rupture.description'
              root={'rupture-irc'}
              accessMenus={accessMenus}
              cdMenuChild={cdMenuChild}
              user={user}
            />

            <IrcMenu
              translate={translate}
              title='kardex.title'
              text='ircMenus.kardex.description'
              root={'kardex'}
              accessMenus={accessMenus}
              cdMenuChild={cdMenuChild}
              user={user}
            />

            <IrcMenu
              translate={translate}
              title='zerocost-dpac-items.title'
              text='zerocost-dpac-items.description'
              root={'zerocost-dpac-items'}
              accessMenus={accessMenus}
              cdMenuChild={cdMenuChild}
              user={user}
            />

          </div>

          <div style={{paddingTop: '40px'}} className='irc-menu-content-container irc-menu-supply'>

            <IrcMenu
              isSupply
              hasTitle
              headerTitle={"Supply"}
              translate={translate}
              title='Acuracidade e efetividade - Supply'
              text='Relatório de acuracidade e efetividade com opções de visualização e detalhamento por ano.'
              root={'supply-accuracy-effectiveness'}
              accessMenus={accessMenus}
              cdMenuChild={cdMenuChild}
              user={user}
            />

            <IrcMenu
              isSupply
              translate={translate}
              title='Histórico de contagem - Supply'
              root={'supply-count-history'}
              text='Detalhamento de posições que foram contados cada loja, por dia, por seção.'
              accessMenus={accessMenus}
              cdMenuChild={cdMenuChild}
              user={user}
              />

            <IrcMenu
              hidden
              isSupply
              translate={translate}
              title='Histórico de contagem - Supply'
              root={'supply-count-history'}
              text='Detalhamento de posições que foram contados cada loja, por dia, por seção.'
              accessMenus={accessMenus}
              cdMenuChild={cdMenuChild}
              user={user}
              />

          </div>

      </>
    )
  }
}

const mapStateToProps = (state) => ({
  menu: state.menuReducer.menu,
  selectedMenu: state.menuReducer.selectedMenu,
})

/* istanbul ignore next */
export const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ accessMenus }, dispatch)

const IrcMenusTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(IrcMenus)

export default connect(mapStateToProps, mapDispatchToProps)(IrcMenusTranslated)

export { IrcMenus }
